import { newAxiosInstance } from "../axiosInstance";
import { FaqResponse } from "@/types/faqTypes";

export const getFaqs = async () => {
    try {
        const response = await newAxiosInstance.get<FaqResponse>(`/faqs/active`);
        return response.data;
    } catch (error) {
        console.error("❌ Error fetching FAQs from:", newAxiosInstance.defaults.baseURL);
        console.error("Error details:", error);
        return {
            status: "error",
            status_code: 500,
            message: "Failed to fetch FAQs",
            result: []
        };
    }
};
